{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Renk Seçici",
  "colorSwatch": "renk örneği",
  "transparent": "saydam",
  "twoDimensionalSlider": "2D sürgü"
}
